export const AppConfig = {
    REQUIRE_SUBSCRIPTIONS: true,
    TRIAL_PERIOD: 30,
    /**
     * If an organization was created before this date, its trial period will start after this date
     */
    COUNT_SUBSCRIPTIONS_FROM: new Date('4/03/2023'),
}
